export enum CategoriesDataValuesEnum {
  connectVacancies = 'connectVacancies',
  fillFields = 'fillFields',
  addFromDataBase = 'addFromDataBase',
  importVacancies = 'importVacancies',
  connectIntegration = 'connectIntegration',
  setupRecruitment = 'setupRecruitment',
  useBrowserExtension = 'useBrowserExtension',
  uploadFromTable = 'uploadFromTable',
  addFromRobota = 'addFromRobota',
  createProjectFromVacancy = 'createProjectFromVacancy',
  eventsAndComments = 'eventsAndComments',
  addTags = 'addTags',
  createInterviews = 'createInterviews',
  rejectionReasons = 'rejectionReasons',
  sendResume = 'sendResume',
  externalInteraction = 'externalInteraction',
  kanban = 'kanban',
  recruitmentTemplates = 'recruitmentTemplates',
  publishVacancies = 'publishVacancies',
  projectStatistics = 'projectStatistics',
  projectReport = 'projectReport',
  projectStagesInfo = 'projectStagesInfo',
  analyzeSources = 'analyzeSources',
  recruitersActivity = 'recruitersActivity',
  projectClosures = 'projectClosures',
  addRequester = 'addRequester',
  configureUserRights = 'configureUserRights'
}
